import { render, staticRenderFns } from "./AudioSettingTab.vue?vue&type=template&id=2be700b4&scoped=true"
import script from "./AudioSettingTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioSettingTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AudioSettingTab.vue?vue&type=style&index=0&id=2be700b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be700b4",
  null
  
)

export default component.exports